import ComfirmOrderService from '@/services/comfirm-order.service';
import type { ShopInfo } from '@/types/shop-info';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import HomeService from '@/services/home.service'
import { Floor } from "@/components/shop/floor";

export type I18 = 'zh-CN' | 'en-US';
export type OperateType = 'Breadcrumb' | 'Header' | 'Footer' | 'HeaderToHome' | 'I18' | 'LoginDialog' | 'Tabbar'

/**
 * 控制系统级别的
 * 控制面包屑是否显示
 * 控制头部是否显示
 * 控制头部返回首页是否显示
 * 控制底部是否显示
 * 控制登录弹窗
 * 控制首页tabbar是否显示
 *  *  */
export const useSystemStore = defineStore('system', () => {
  const shopConfig = ref<ShopInfo>();
  const isShowBreadcrumb = ref(true);
  const isShowHeader = ref(true);
  const isShowFooter = ref(true);
  const isShowHeaderToHome = ref(false);
  const currentI18 = ref<I18>('zh-CN');
  const isShowLoginDialog = ref(false);
  const isShowTabbar = ref(true); // 显示首页tabbar
  const currentNavPath = ref('/') // 当前首页路由路径
  const locationCityId = ref(''); // 当前城市Id
  const comfirmOrderService = new ComfirmOrderService();
  const components = ref<Floor[]>([]);
  const homeService = new HomeService()
  const skeleton = ref(false);

  const getUserPositionCity = async() => {
    const {data, statusCode } = await comfirmOrderService.getUserPositionCity();
    if (data && statusCode === 200) {
      locationCityId.value = data.cityId || '3101';
    }
  }
  if(!locationCityId.value) {
    getUserPositionCity();
  }
  function toggleSetting(type: OperateType, isShow: boolean): any;
  function toggleSetting(type: OperateType, lan: I18): any;
  function toggleSetting(type: OperateType, payload: any) {
    if (typeof payload === 'boolean') {
      const isShow = payload;
      if (type === 'Breadcrumb') {
        isShowBreadcrumb.value = isShow;
      }
      if (type === 'Header') {
        isShowHeader.value = isShow;
      }
      if (type === 'Footer') {
        isShowFooter.value = isShow;
      }
      if (type === 'HeaderToHome') {
        isShowHeaderToHome.value = isShow;
      }
      // 强制页面登录
      if (type === 'LoginDialog') {
        isShowLoginDialog.value = isShow;
      }
      if (type === 'Tabbar') {
        isShowTabbar.value = isShow;
      }
    } else {
      currentI18.value = payload as I18;
    }
  };

  function toggleNavPath (path: string) {
    currentNavPath.value = path
  }

  function saveShopConfig (config: ShopInfo) {
    shopConfig.value = config
  }

  async function getComponentData(query: {id?: string | undefined, page?: string}) {
    skeleton.value = true;
    try {
      const { id, page } = query;
      const params: any = {
        cityId: 'BL1034',
        page,
        ...(id ? { id } : {}),
      }
      const { statusCode, data } = await homeService.getFloorInfos(params)
      skeleton.value = false;
      if (statusCode === 200 && data) {
        components.value = data?.components || [];
      }
    } catch (error) {
      skeleton.value = false;
      components.value = [];
    }
  }

  return {
    shopConfig,
    currentI18,
    locationCityId,
    isShowBreadcrumb,
    isShowHeader,
    isShowFooter,
    isShowHeaderToHome,
    toggleSetting,
    isShowLoginDialog,
    isShowTabbar,
    toggleNavPath,
    currentNavPath,
    saveShopConfig,
    getComponentData,
    components,
    skeleton,
  };

}, { persist: true })
